import React from 'react';
import PropTypes from 'prop-types';

// Utils
import bemify from 'utils/bemify';

// Components
import Button from 'components/button';

// Styles
import stylesModule from './styles.module.scss';


const styles = bemify(stylesModule);

const RestaurantMenuSidebar = ({
  children = null,
  className = null,
  onClose = () => {},
  translations = null
}) => (
  <section className={`${styles.restaurantMenuSidebar}${className ? ` ${className}` : ''}`}>
    <header className={styles.restaurantMenuSidebar__header}>
      <Button
        icon="chevron-left"
        iconPosition="left"
        paddingSize="none"
        text={translations?.returnButtonLabel}
        theme="unstyled"
        onClick={onClose}
      />
    </header>
    {children}
  </section>
);

RestaurantMenuSidebar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClose: PropTypes.func,
  translations: PropTypes.shape({
    returnButtonLabel: PropTypes.string
  })
};

export default RestaurantMenuSidebar;
